import getStore from "../store/store";

export default function areNotificationsEnabled(): boolean {
    return !!getStore().global?.notificationsEnabled;
}
